export default {
    render: ({ x = 0, y = 0, color = 'lime' }) => {
        return `<circle cx="${x}" cy="${y}" style="fill:${color}; stroke-width: 0" r="6" />`
    },
}
